import { Moon, Sun } from 'lucide-react'
import { useThemeStore } from '@/stores/themeStore'

// Theme toggle. `pill` variant is used on the login screen (top-right), `round`
// in the app topbar. Shows the icon of the theme you'd switch TO.
export function ThemeToggle({ variant = 'round' }: { variant?: 'round' | 'pill' }) {
  const theme = useThemeStore((s) => s.theme)
  const toggle = useThemeStore((s) => s.toggle)
  const Icon = theme === 'dark' ? Sun : Moon

  if (variant === 'pill') {
    return (
      <button
        type="button"
        onClick={toggle}
        title="Toggle theme"
        aria-label="Toggle theme"
        className="flex items-center gap-1.5 rounded-full border border-border bg-surface px-3 py-2 text-[13px] font-semibold text-muted-foreground shadow-wha-sm"
      >
        <Icon className="h-4 w-4" />
      </button>
    )
  }

  return (
    <button
      type="button"
      onClick={toggle}
      title="Toggle theme"
      aria-label="Toggle theme"
      className="flex h-[38px] w-[38px] items-center justify-center rounded-full border border-border bg-surface-2 text-muted-foreground transition-colors hover:text-foreground"
    >
      <Icon className="h-[18px] w-[18px]" />
    </button>
  )
}
